import moment from "moment";

export const handleCurrentMonthDate = () => {
  const today = moment();
  const dateTo = today.format("MMM D, YYYY");
  const dateFrom = today.clone().subtract(29, "days").format("MMM D, YYYY");

  const dateRange = `${dateFrom} - ${dateTo}`;
  return dateRange;
};

export const convertDateRange = (dateRange) => {
  // Split the range string into two dates
  const [startDateStr, endDateStr] = dateRange.split(" - ");

  // Parse each date and format them as 'YYYY-MM-DD'
  const dateFrom = moment(startDateStr, "MMM D, YYYY").format("YYYY-MM-DD");
  const dateTo = endDateStr ? moment(endDateStr, "MMM D, YYYY").format("YYYY-MM-DD") : "";

  return { dateFrom, dateTo };
};
